import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faSave } from "@fortawesome/free-solid-svg-icons"

export const Save = (props) => {
  return <FontAwesomeIcon faIcon={faSave} {...props} />
}
